module.exports = __webpack_public_path__ + "static/media/phone.01df9ecf.svg";